// Names of storage keys containing various authentication values
export const storageKeyPassword = 'auth.password';
export const storageKeyToken = 'auth.token';
export const storageKeyUsername = 'auth.username';

// Name of the cookie key containing the refresh token set by SmartPay
export const cookieKeyRefreshToken = 'refreshToken';
